<template>
  <div>
    <van-nav-bar :border="false"
                 title="完成率排名"
                 left-arrow
                 @click-left="$router.back()"
    />
    <ul class="list-rank-menu">
      <li class="item" v-for="(item,index) in rankList" :key="index">
        <div class="num" :class="[{'num1':item.OverMoneyOrderNumber==1},{'num2':item.OverMoneyOrderNumber==2},{'num3':item.OverMoneyOrderNumber==3}]">
          {{ item.OverMoneyOrderNumber }}
        </div>
        <div class="info-wrap">
          <img class="img" :src="item.Item.HeadImgUrl" alt="">
          <div class="info">
            <p class="p1">{{ item.Item.Name }}</p>
            <p class="p2">{{ item.UserDepName }}</p>
          </div>
        </div>
        <div class="number">{{ item.OverMoney }}%</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rankList: [],
    }
  },
  mounted() {
    this.WebGetBUserMoneyLst();
  },
  methods: {
    WebGetBUserMoneyLst() {
      let data = {
        // UserSysno: localStorage.getItem('UserSysno'),
        ComSysno: localStorage.getItem('UserComSysno'),
        StartDate: this.$route.query.date || '',
        EndDate: this.$route.query.date || ''
      }
      this.$baseajax.normalJsonp(this.$base.baseapi + '/WebGetBUserMoneyLst', data, res => {
        console.log(res);
        res = res.WebGetBUserMoneyLstResult
        if (res.ResponseCode == 1) {
          if (res.AllCount) {
            this.rankList = res.ItemLst
          }
        }
      }, err => {
      })
    }
  },
}
</script>

<style lang="less" scoped>
.list-rank-menu {
  padding-left: 0.28rem;
  padding-right: 0.28rem;
  padding-bottom: 0.28rem;

  .item {
    margin-top: 0.28rem;
    padding: .5rem .5rem .5rem 0;
    background-color: #ffffff;
    box-shadow: 0rem 0rem 0.17rem 0rem rgba(30, 34, 121, 0.13);
    border-radius: 0.27rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .num {
      font-size: 0.87rem;
      color: #888888;
      width: 2rem;
      font-weight: 700;
      text-align: center;
      border-right: 1px solid #eee;

      &.num1 {
        color: #ff6000;
      }

      &.num2 {
        color: #ff9600;
      }

      &.num3 {
        color: #ffc16a;
      }
    }

    .info-wrap {
      display: flex;
      align-items: center;

      .img {
        width: 1.47rem;
        height: 1.47rem;
        border-radius: 100%;
        margin-right: 0.6rem;
      }

      .p1 {
        font-size: 0.4rem;
        color: #333333;
      }

      .p2 {
        font-size: 0.33rem;
        color: #666666;
      }
    }

    .number {
      font-size: 0.4rem;
      color: #333;
      width: 1.5rem;
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/Rank.vue